import { Grid, Skeleton } from "@mui/material"


export function ProfileSkeleton(){
  return (
    <Grid sx={{ display: 'flex', flexDirection: 'column', gap: { xs: 1, md: 2 } }}>
      <Skeleton variant="rounded"  sx={{ height: { xs: 110, md: 180 }, width: '100%', borderRadius: 4}} />

      <Grid container spacing={{ xs: 1, md: 2 }} sx={{ display: 'flex' }}>
        <Grid item xs={12} md={8} sx={{ display: 'flex', flexDirection: 'column', gap: { xs: 1, md: 2 } }}>
          <Skeleton variant="rounded"  sx={{ height: { xs: 90, md: 130 }, width: '100%', borderRadius: 4}} />
          <Skeleton variant="rounded"  sx={{ height: { xs: 130, md: 180 }, width: '100%', borderRadius: 4}} />
          <Skeleton variant="rounded"  sx={{ height: { xs: 180, md: 350 }, width: '100%', borderRadius: 4}} />
        </Grid>

        <Grid item xs={12} md={4}>
          <Skeleton variant="rounded"  sx={{ height: { xs: 90, md: 130  }, width: '100%', borderRadius: 4}} />
        </Grid>
      </Grid>

    </Grid>
  )
}

export function ProfileMenuSkeleton(){
  return (
    <Skeleton variant="rounded" sx={{ height: { xs: 120, md: 350  }, width: '100%', borderRadius: 4}} />
  )
}

export function ProfileDeviceSkeleton(){
  return (
    <Grid container xs={12} md={8} gap={{ xs: 1, md: 2 }}>
      {Array.from({ length: 10 }).map((_, index) => (
        <Skeleton variant="rounded" sx={{ height: { xs: 100, md: 90  }, width: '100%', borderRadius: 4}} />
      ))}
    </Grid>
  )
}

export function ProfileDocumentsSkeleton(){
  return (
    <Grid container xs={12} md={12} gap={{ xs: 1, md: 2 }}>
      {Array.from({ length: 10 }).map((_, index) => (
        <Skeleton variant="rounded" sx={{ height: { xs: 120, md: 110  }, width: '100%', borderRadius: 4}} />
      ))}
    </Grid>
  )
}